import React, {useMemo, useState} from 'react';
import {connect} from "react-redux";
import {EDGE_LABELS, SIDEBAR_NAVIGATION_BUTTONS} from "../../../../../constants";
import SqftNavEdgesFeature from "./SqftNavEdgesFeature";
import SqftNavEdgesMiteredButton from "./SqftNavEdgesMiteredButton";
import {getMiterEdgeFeature} from "../../../../../helpers/featureHelper";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import SQFTFeaturesHeader from "../../cabinet/toolMenu/commonParts/SQFTFeaturesHeader";
import useFetchFeatures from "../../../../../hocs/useFetchFeatures";
import LoadingSpinner from "../../../../../../ui/loadingSpinner";

const SqftNavEdges = (props) => {
  const { menuOpened } = props;
  const [selectedEdge, setSelectedEdge] = useState(0);

  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.edge;

  const partIds = useMemo(() => {
    if (!expanded) return [];
    return [EDGE_LABELS.edge_profile, EDGE_LABELS.center_island_edge];
  }, [expanded]);

  const { featuresData, isLoading } = useFetchFeatures(partIds, "", {}, true, false, true);

  const navItems = useMemo(() => {
    if (!featuresData) return [];
    const main = featuresData[EDGE_LABELS.edge_profile];
    const opposite = featuresData[EDGE_LABELS.center_island_edge];

    const mainHasAny = !!(main?.navItemsFromFeatureGroup?.length);
    const oppositeHasAny = !!(opposite?.navItemsFromFeatureGroup?.length);

    if (mainHasAny) return main.navItemsFromTheWizardFiltered || [];
    if (oppositeHasAny) return opposite.navItemsFromTheWizardFiltered || [];
    return [];
  }, [featuresData]);

  const headerPartId = useMemo(() => {
    const main = featuresData?.[EDGE_LABELS.edge_profile];
    const opposite = featuresData?.[EDGE_LABELS.center_island_edge];
    if (main?.navItemsFromFeatureGroup?.length) return main.partId;
    if (opposite?.navItemsFromFeatureGroup?.length) return opposite.partId;
    return undefined;
  }, [featuresData]);

  const miterEdgeFeature = getMiterEdgeFeature();

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")} data-content="edge" id="edge-overlay">
      <div className="content-inner">
        <SQFTFeaturesHeader
          headerTitle={""}
          showSearch={false}
          showViewTypeSwitcher={false}
          partId={headerPartId}
        />

        <ul className="lightbox-options-wrapper" id="edge-overlay-items">
          {!expanded ? null : isLoading
            ? <LoadingSpinner />
            : navItems.map(navItem => (
              <SqftNavEdgesFeature
                selectedEdge={selectedEdge}
                setSelectedEdge={setSelectedEdge}
                navItem={navItem}
                key={navItem.part.dbFeature.id}
              />
            ))
          }

          {miterEdgeFeature
            ? <SqftNavEdgesMiteredButton
              selectedEdge={selectedEdge}
              setSelectedEdge={setSelectedEdge}
            />
            : null}
        </ul>

        <div className="ui-loader"/>
      </div>
    </div>
  );
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  const { clearCacheTick } = store.sqftMenuState || { clearCacheTick: 0 };
  return { menuOpened, clearCacheTick };
};

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavEdges);
